import wxFactory from "./wxFactory.js";
import isWxClient from "./tools/isWxClient.js";
import useUserStore from "@/store/user";
const userStore = useUserStore();

let wxapp = "";

export const wxlogin = async () => {
	if (!isWxClient()) return true;
	console.log("%c -----> 001", "font-size:13px; background:pink; color:#bf2c9f;", "微信登录初始化");
	const wxInstance = new wxFactory({
		scope: "snsapi_userinfo", // snsapi_userinfo snsapi_base
		appid: "wx2b227e5c59ed06b4",
		envid: "prod-yaoland-001-9fff60f26267ad5",
		signature: window.location.href,
		wxserver: "yaoland-wx-pay", //微信云服务器 名称
	});
	wxapp = wxInstance;
	try {
		const { userInfo } = await wxInstance.login();
		userStore.wxloginState = true;
		userStore.avatarUrl = userInfo.avatarUrl;
		userStore.nickName = userInfo.nickName;
		userStore.openId = userInfo.openId;

		console.log("%c -----> 001 - userItem");
		console.log(userItem);
		// wxInstance.wxConfig();
		return true;
	} catch (error) {
		console.log("%c -----> 001 error", "font-size:13px; background:pink; color:#bf2c9f;", error);
		return true;
	}
};

export const getWxApp = () => wxapp;
